import styled from 'styled-components';

export const Wrapper = styled.div`
  background: rgba(255, 255, 255, 0.7);
  border-radius: 20px;
  display: flex;
  gap: 0.5rem;
`;
